import {throttle} from './../../../shared/pipes/throttle';
import {acceptorsSlice} from '../../reducers/acceptors';
import {HttpWrapperOptions} from '../../../shared/httpWrapper';
import {apiUrls} from '../../../shared/constants/urls';
import {getApiRoute} from '../../../shared/pipes/getApiRoute';
import {AppThunk} from '../index';
import {httpService} from '../../../shared/httpWrapper';

export const getAcceptors = (): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const list = await httpService.get(
        getApiRoute(apiUrls.getAcceptorsList),
        new HttpWrapperOptions().Wait(false).Errors(true).ThrowException(false),
      );
      if (list) {
        dispatch(acceptorsSlice.actions.setAcceptors(list));
      }
    }, 900);
  };
};

export const getListAcceptorCategories = (): AppThunk => {
  return async (dispatch) => {
    throttle(async () => {
      const list = await httpService.get(
        getApiRoute(apiUrls.getListAcceptorCategories),
        new HttpWrapperOptions().Errors(true),
      );
      if (list) {
        dispatch(acceptorsSlice.actions.setListAcceptorCategories(list));
      }
    }, 900);
  };
};

export const getAcceptorBranches = (id: number): AppThunk => {
  return async (dispatch) => {
    const list = await httpService.get(
      getApiRoute(apiUrls.getAcceptorBranches, null, {uid: id}),
      new HttpWrapperOptions().Errors(true),
    );
    if (list) {
      dispatch(acceptorsSlice.actions.setAcceptorBranches(list));
    }
  };
};
